var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 .5a.5.5 0 1 0-1 0v7.293L.854 6.647a.5.5 0 0 0-.708.707l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 1 0-.708-.707L3 7.793zm-3 11a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5M9.5 0a.5.5 0 0 1 .5.5v7.293l1.146-1.146a.5.5 0 1 1 .707.707l-2 2a.5.5 0 0 1-.706 0l-2-2a.5.5 0 0 1 .707-.707L9 7.793V.5a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })));
});
const SvgFetchsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFetchsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjAwMDAzIDAuNUMzLjAwMDAzIDAuMjIzODU4IDIuNzc2MTggMCAyLjUwMDAzIDBDMi4yMjM4OSAwIDIuMDAwMDMgMC4yMjM4NTggMi4wMDAwMyAwLjVWNy43OTI4N0wwLjg1MzUwNyA2LjY0NjY0QzAuNjU4MjIgNi40NTE0IDAuMzQxNjM3IDYuNDUxNDUgMC4xNDY0IDYuNjQ2NzNDLTAuMDQ4ODM2MiA2Ljg0MjAyIC0wLjA0ODc5NDkgNy4xNTg2IDAuMTQ2NDkzIDcuMzUzODRMMi4xNDY1MyA5LjM1MzM1QzIuMzQxNzggOS41NDg1NiAyLjY1ODMgOS41NDg1NSAyLjg1MzU1IDkuMzUzMzVMNC44NTM1MSA3LjM1MzgzQzUuMDQ4OCA3LjE1ODU5IDUuMDQ4ODMgNi44NDIwMSA0Ljg1MzU5IDYuNjQ2NzNDNC42NTgzNSA2LjQ1MTQ0IDQuMzQxNzcgNi40NTE0MSA0LjE0NjQ5IDYuNjQ2NjVMMy4wMDAwMyA3Ljc5Mjg0VjAuNVpNMS40ODU0ZS0wOSAxMS41QzEuNDg1NGUtMDkgMTEuMjIzOSAwLjIyMzg1OCAxMSAwLjUgMTFIMTEuNUMxMS43NzYxIDExIDEyIDExLjIyMzkgMTIgMTEuNUMxMiAxMS43NzYxIDExLjc3NjEgMTIgMTEuNSAxMkgwLjVDMC4yMjM4NTggMTIgMS40ODU0ZS0wOSAxMS43NzYxIDEuNDg1NGUtMDkgMTEuNVpNOS41MDAwMyAwQzkuNzc2MTggMCAxMCAwLjIyMzg1OCAxMCAwLjVWNy43OTI4NEwxMS4xNDY1IDYuNjQ2NjVDMTEuMzQxOCA2LjQ1MTQxIDExLjY1ODQgNi40NTE0NCAxMS44NTM2IDYuNjQ2NzNDMTIuMDQ4OCA2Ljg0MjAxIDEyLjA0ODggNy4xNTg1OSAxMS44NTM1IDcuMzUzODNMOS44NTM1NSA5LjM1MzM1QzkuNjU4MyA5LjU0ODU1IDkuMzQxNzggOS41NDg1NiA5LjE0NjUzIDkuMzUzMzVMNy4xNDY0OSA3LjM1Mzg0QzYuOTUxMjEgNy4xNTg2IDYuOTUxMTYgNi44NDIwMiA3LjE0NjQgNi42NDY3M0M3LjM0MTY0IDYuNDUxNDUgNy42NTgyMiA2LjQ1MTQgNy44NTM1MSA2LjY0NjY0TDkuMDAwMDMgNy43OTI4N1YwLjVDOS4wMDAwMyAwLjIyMzg1OCA5LjIyMzg5IDAgOS41MDAwMyAwWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";